import {
  INIT_STATE,
  SAVE_ELECT_DATA,
  INIT_ISSUEPSGS,
  SELECT_INVOICETITLE_TYPE,
  GET_INVOICE,
} from './actions';

let issuePsg = {
  ticketNo: '', // 票号
  ticketType: 'ET', // ET | EMD | TKT
  businessType: '退票手续费',
  mobilePhone: '',
  email: '',
  printTime: '', // 开票日期 yyyy-mm-dd
  buyername: '', // 发票抬头（个人或公司）
  buyertaxno: '', // 纳税人识别号
  buyeraddtel: '', // 地址电话
  buyerbankno: '', // 开户行及账号
  amount: '', // 金额
  comments: '', // 发票栏备注信息
  psgname: '', // 旅客姓名
  idtype: '', // 证件类型
  idcard: '', // 证件号码
  psgType: '', // 旅客类型
  option: '0', // 0 个人 1 企业 2 非营业性(非预约接口的参数)
  contactNo: '', // 公司电话(非预约接口的参数)
  address: '', // 地址(非预约接口的参数)
  depositBank: '', // 开户行(非预约接口的参数)
  bankCardNo: '', // 账号,(非预约接口的参数)
  peerRowPsgs: [], // 关联开具的同行人，存票号(非预约接口的参数)
  useInvoiceTitle: '', // 是否使用发票抬头数据，存invoiceId(非预约接口的参数)
  isEditOriginInvoiceTitle: false, // 是否修改了原发票抬头(非预约接口的参数)
};

const initialState = {
  invoiceTitleData: [], // 登录者的发票抬头数据
  issuePsgs: [], // 开具旅客信息
  reservePsgs: [], // 已预约旅客，存票号
};

export default function electronicInvoiceReducer(state = initialState, action) {
  switch (action.type) {
    case INIT_STATE:
      return initialState;
    case INIT_ISSUEPSGS:
      const issuePsgs = action.psgs.map(item => {
        return Object.assign({}, issuePsg, item);
      });
      return Object.assign({}, state, {
        issuePsgs,
      });
    case SAVE_ELECT_DATA:
      const reservePsgs = [...state.reservePsgs];
      const psg = state.issuePsgs[action.n];
      const newIssuePsgs = [...state.issuePsgs];
      if (reservePsgs.indexOf(action.data.ticketNo) === -1)
        reservePsgs.push(action.data.ticketNo);
      newIssuePsgs.splice(action.n, 1, Object.assign({}, psg, action.data));
      return Object.assign({}, state, { issuePsgs: newIssuePsgs, reservePsgs });
    case `${GET_INVOICE}_SUCCESS`:
      return Object.assign({}, state, {
        invoiceTitleData:
          action.payload.data.SvcPcInvoiceRes.svcPcInvoiceDto || [],
      });
    case SELECT_INVOICETITLE_TYPE:
      state.issuePsgs[action.n].option = action.option;
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/routes/electronicInvoice/modules/electronicInvoice.js